import { HashLink } from "react-router-hash-link";

import { useScrollPosition } from "../../hooks/useScrollPositiion";
import utils from "../../utils/utils";
import Banner1Img from "../../assets/images/new/new_banner.svg";

import { Homepage } from "../../@types/lang";
import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

type Props = {
  lang: Homepage;
};

const Banner = ({ lang }: Props) => {
  const [bannerImg, setBannerImg] = useState(null);
  const { scrollWithOffset } = utils;

  const scrollPosition = useScrollPosition();

  useEffect(() => {
    setTimeout(() => setBannerImg(Banner1Img), 500);
  }, []);
  return (
    <>
      {/* Banner Hero SECTION */}
      <div className="mb-16">
        <div className="w-full relative max-h-[600px] lg:max-h-[1000px] lg:h-[775px] h-80">
          <div className="mx-auto h-80 lg:h-full relative w-full">
            <div className="absolute top-0 bottom-0 left-0 right-0 w-auto h-80 lg:h-[775px] bg-black/10"></div>
            <AnimatePresence>
              {!bannerImg ? (
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.1 }}
                  exit={{ opacity: 0 }}
                  className="h-80 animate-pulse bg-gray-400 lg:h-[775px] w-full max-sm:object-cover"
                ></motion.div>
              ) : (
                <motion.img
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.25 }}
                  exit={{ opacity: 0 }}
                  src={bannerImg}
                  alt="hero"
                  className="h-80 lg:h-[775px] w-full object-cover"
                  loading="lazy"
                />
              )}
            </AnimatePresence>
          </div>
          <div className="absolute top-[12%] md:top-[18%] max-sm:px-6 w-full lg:w-3/4 h-full flex flex-col left-1/2 z-10 gap-1 lg:gap-4 -translate-x-[50%] text-center mx-auto">
            <p className="font-semibold text-xs md:text-sm lg:text-lg text-black">
              {lang.banner_little_text_first || "-"}
            </p>
            <h3 className="font-semibold text leading-[2rem] md:text-xl lg:text-[40px] text-black my-2 lg:!leading-[3.6rem] lg:w-3/4 lg:mx-auto">
              {lang.banner_title || "-"}
            </h3>
            {/* <p className="font-semibold text-xs md:text-sm lg:text-lg text-black">
              {lang.banner_little_text_second || "-"}
            </p> */}
            <HashLink
              scroll={(el) =>
                scrollWithOffset(el, scrollPosition ? -100 : -155)
              }
              to="/#aboutus"
              className="bg-[#504E48] hover:bg-[#504E04] text-center mt-4 mx-auto rounded-[10px] px-6 py-3 text-white text-xs lg:text-lg cursor-pointer"
            >
              {lang.banner_button_link || "-"}
            </HashLink>
          </div>
        </div>
      </div>
    </>
  );
};

export default Banner;
